import { CreateDeceasedDetailsCmConstant } from '../create-deceased-details-cm/create-deceased-details-cm.constants';
export class DeceasedDtailsCustomValidators {
    static CompareDateToToday(control) {
        const dateOfBirth = control.value;
        if (!dateOfBirth)
            return null;
        const dateOfBirthToDate = new Date(dateOfBirth);
        const isWrong = DeceasedDtailsCustomValidators.compareAnyDateToTday(dateOfBirthToDate);
        return isWrong ? { wrong: isWrong } : null;
    }
    static CompareDateToDateOfDeath(control) {
        if (!control.get(CreateDeceasedDetailsCmConstant.DATE_OF_BIRTH_CONTROL) ||
            !control.get(CreateDeceasedDetailsCmConstant.DATE_OF_DEATH_CONTROL))
            return null;
        const dateOfBirth = control.get(CreateDeceasedDetailsCmConstant.DATE_OF_BIRTH_CONTROL).value;
        const dateOfdeath = control.get(CreateDeceasedDetailsCmConstant.DATE_OF_DEATH_CONTROL).value;
        if (!dateOfdeath)
            return null;
        const birthToDeathIsWrong = DeceasedDtailsCustomValidators.compareDateOfBirthToDateOfDeath(new Date(dateOfBirth), new Date(dateOfdeath));
        const deathToTodayIsWrong = DeceasedDtailsCustomValidators.compareAnyDateToTday(new Date(dateOfdeath));
        if (birthToDeathIsWrong || deathToTodayIsWrong)
            control.get(CreateDeceasedDetailsCmConstant.DATE_OF_DEATH_CONTROL).setErrors({ wrong: true });
        return birthToDeathIsWrong || deathToTodayIsWrong ? { wrong: birthToDeathIsWrong || deathToTodayIsWrong } : null;
    }
    // Check if date of death is wrong
    static compareDateOfBirthToDateOfDeath(dateOfBirth, dateOfDeath) {
        return (dateOfDeath < dateOfBirth);
    }
    // if any date is greater than today
    static compareAnyDateToTday(date) {
        const today = new Date();
        return (date > today);
    }
}
